import { useTrackPageView } from "@/lib/posthog";
import { usePage } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { ReactNode, useEffect } from "react";
import { Toaster } from "./ui/toaster";

type Props = {
  children: ReactNode;
  user?: {
    public_id: string;
    email: string;
  };
};

function identifyPosthog(user: { public_id: string; email: string }) {
  posthog.identify(user.public_id, {
    email: user.email,
  });
}

function setSentryUser(user: { public_id: string; email: string }) {
  Sentry.setUser({
    id: user.public_id,
    email: user.email,
  });
}

export default function Layout({ children }: Props) {
  const { props } = usePage();
  const user = props.user as { public_id: string; email: string } | undefined;

  useTrackPageView();

  // Run the posthog identify any time the user changes
  useEffect(() => {
    if (user?.public_id) {
      if (!posthog._isIdentified()) {
        identifyPosthog(user);
      }
      setSentryUser(user);
    }
  }, [user?.public_id]);

  return (
    <div>
      {children}
      <Toaster />
    </div>
  );
}
